/*
  Cal.com inline booking, for any [data-cal-embed] box: data-cal-link is the Cal.com
  username/event (e.g. vortexrugby/team-store), data-cal-ns a namespace for this embed.
*/
(() => {
  const boxes = document.querySelectorAll('[data-cal-embed]');
  if (!boxes.length) return;
  /* Cal.com's embed loader, as published in their docs. */
  (function (C, A, L) {
    const p = function (a, ar) { a.q.push(ar); };
    const d = C.document;
    C.Cal = C.Cal || function () {
      const cal = C.Cal;
      const ar = arguments;
      if (!cal.loaded) {
        cal.ns = {};
        cal.q = cal.q || [];
        d.head.appendChild(d.createElement('script')).src = A;
        cal.loaded = true;
      }
      if (ar[0] === L) {
        const api = function () { p(api, arguments); };
        const namespace = ar[1];
        api.q = api.q || [];
        if (typeof namespace === 'string') {
          cal.ns[namespace] = cal.ns[namespace] || api;
          p(cal.ns[namespace], ar);
          p(cal, ['initNamespace', namespace]);
        } else p(cal, ar);
        return;
      }
      p(cal, ar);
    };
  })(window, 'https://app.cal.com/embed/embed.js', 'init');

  boxes.forEach((box, i) => {
    const link = (box.dataset.calLink || '').replace(/^https?:\/\/(app\.)?cal\.com\//, '');
    if (!link) return;
    const ns = box.dataset.calNs || `vx${i}`;
    if (!box.id) box.id = `CalEmbed${i}`;
    // load the calendar when it's nearly on screen, not on page load
    const start = () => {
      window.Cal('init', ns, { origin: 'https://cal.com' });
      window.Cal.ns[ns]('inline', { elementOrSelector: `#${box.id}`, calLink: link, config: { layout: 'month_view' } });
      window.Cal.ns[ns]('ui', { layout: 'month_view', cssVarsPerTheme: { light: { 'cal-brand': '#111111' } } });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '600px' });
      io.observe(box);
    } else start();
  });
})();
